/**
 * Account margin for the client platform.
 *
 * Mirror of shark-backend/engines/cfd/modules/margin-calc.js `accountMargin`, which is the source
 * of truth. The two repos share no package, so this is a deliberate copy — keep them in step.
 *
 * The guard that matters is `o.type > 1`. Pending orders — Buy Limit 2, Sell Limit 3, Buy Stop 4,
 * Sell Stop 5 — do NOT consume margin: the engine has never counted them (calcMargin sums
 * STATUS.OPEN only). This calculation was written out five times across the components and lost
 * the guard in every one, while the P&L loop beside each one kept it. Trello xsCIAo1S.
 *
 * Note `GET /cfd/:account_id/orders` returns OPEN *and* PENDING orders, so the caller's order map
 * genuinely contains both. Filtering is this function's job, not the caller's.
 *
 * The absolute value is taken PER SYMBOL. Summing across symbols first would zero the margin of an
 * account holding a long and a short in unrelated instruments.
 */
export const accountMargin = (orders) => {
    const marginBySymbol = {}

    for (const n in orders) {
        const o = orders[n]

        if (o.type > 1) {
            continue
        }

        if (marginBySymbol[o.symbol] === undefined) {
            marginBySymbol[o.symbol] = 0
        }

        marginBySymbol[o.symbol] += o.type % 2 ? -o.margin : o.margin
    }

    let margin = 0

    for (const n in marginBySymbol) {
        margin += Math.abs(marginBySymbol[n])
    }

    return margin
}
